import Link from 'next/link'
import styled from 'styled-components'

import { BlogItem } from '@/components/elements/Blog/BlogItem'
import { Button } from '@/components/elements/Button'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

import type { Blog } from '@/types/blog'

type Props = {
  blogList: readonly Blog[]
}

export const RecentlyBlogList = ({ blogList }: Props) => {
  return (
    <div>
      <SectionTitle
        titleText="TRIAL Blog"
        subTitleText="広報ブログ"
        color="normal"
      />
      <Spacer h={{ sp: 40, pc: 70 }} />
      <BlogList>
        {blogList.map((blog) => (
          <BlogItem {...blog} key={blog._id} />
        ))}
      </BlogList>
      <MoreButtonWrapper>
        <Link href="/news/blog" passHref>
          <a>
            <Button btnStyle="transparent">一覧を見る</Button>
          </a>
        </Link>
      </MoreButtonWrapper>
    </div>
  )
}

const BlogList = styled.div`
  display: flex;
  align-items: center;
  gap: 46px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    justify-content: normal;
    gap: 24px;
  }
`

const MoreButtonWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1047px) {
    margin-top: 40px;
  }
`
